(() => {
  const ROOT = 'product-info.hm-product-page';
  function moveWishlist(root) {
    if (!root || root.dataset.hmWishlistOverlay !== 'true') return false;
    const overlay = root.querySelector('[data-hm-wishlist-overlay]');
    const info = root.querySelector('.product__info-container');
    if (!overlay || !info) return false;
    const controls = Array.from(info.querySelectorAll('button,a,[role="button"],[class*="wishlist" i] button,[class*="wish-list" i] button,[data-wishlist] button'));
    const visible = el => { const r=el.getBoundingClientRect(); return r.width>0 && r.height>0 && getComputedStyle(el).display!=='none' && getComputedStyle(el).visibility!=='hidden'; };
    const label = el => [el.textContent||'',el.getAttribute('aria-label')||'',el.getAttribute('title')||'',typeof el.className==='string'?el.className:''].join(' ').toLowerCase().replace(/\s+/g,' ');
    let button=controls.find(el=>!overlay.contains(el)&&visible(el)&&/add to wishlist/.test(label(el)));
    if(!button) button=controls.find(el=>!overlay.contains(el)&&visible(el)&&/wishlist|wish-list/.test(label(el)));
    if(!button) return false;
    button.setAttribute('aria-label',button.getAttribute('aria-label')||'Add to wishlist');
    button.classList.add('hm-wishlist-overlay__control');
    const walker=document.createTreeWalker(button,NodeFilter.SHOW_TEXT), nodes=[];
    while(walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node=>{if(/add\s+to\s+wishlist/i.test(node.nodeValue||'')) node.nodeValue='';});
    button.querySelectorAll('span,p,small,label').forEach(el=>{if(/^\s*add\s+to\s+wishlist\s*$/i.test(el.textContent||'')&&!el.querySelector('svg,img,i,[class*="heart" i],[class*="icon" i]'))el.style.display='none';});
    if(!button.querySelector('svg,img,i,[class*="heart" i],[class*="icon" i]'))button.dataset.hmHeartFallback='true';
    overlay.appendChild(button); overlay.hidden=false; overlay.classList.add('is-active');
    return true;
  }
  function moveStockNote(root) {
    if (!root) return;
    const stockNote = root.querySelector('.hm-stock-note[id^="Inventory-"]');
    const purchaseBlock = root.querySelector('.hm-product-purchase-block');
    if (!stockNote || !purchaseBlock) return;
    if (stockNote.previousElementSibling !== purchaseBlock) {
      purchaseBlock.insertAdjacentElement('afterend', stockNote);
    }
  }

  function hideDuplicateStockAlerts(root) {
    if (!root) return;
    root.querySelectorAll('.product__inventory:not(.hm-stock-note)').forEach((alert) => {
      alert.style.setProperty('display', 'none', 'important');
      alert.setAttribute('aria-hidden', 'true');
    });
    root.querySelectorAll('[role="status"], [class*="stock" i], [class*="inventory" i], [data-inventory], [data-stock]').forEach((node) => {
      if (node.closest('.hm-stock-note')) return;
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (/only\s+\d+\s+items?\s+left\s+in\s+stock!?/i.test(text)) {
        const alert = node.closest('.product__inventory') || node;
        if (alert.closest('.hm-stock-note')) return;
        alert.style.setProperty('display', 'none', 'important');
        alert.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function init(root) {
    if (!root) return;
    moveStockNote(root);
    hideDuplicateStockAlerts(root);
    moveWishlist(root);
    if (root.dataset.hmProductObserverStarted === 'true' || !window.MutationObserver) return;
    root.dataset.hmProductObserverStarted = 'true';
    const observer = new MutationObserver(() => {
      moveStockNote(root);
      hideDuplicateStockAlerts(root);
      moveWishlist(root);
    });
    /* Keep watching even when the wishlist overlay is disabled: inventory apps
       often inject their red urgency message after the initial page render. */
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  async function handleBuyNow(event) {
    const button = event.target && event.target.closest ? event.target.closest('[data-hm-buy-now]') : null;
    if (!button || button.disabled) return;
    const form = button.closest('form') || document.getElementById(button.dataset.productFormId);
    if (!form) return;
    event.preventDefault();
    if (button.dataset.hmBusy === 'true') return;

    button.dataset.hmBusy = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const label = button.querySelector('span') || button;
    const originalLabel = label.textContent || 'Buy it now';
    label.textContent = 'Processing…';

    const errorWrapper = form.querySelector('.product-form__error-message-wrapper');
    const errorMessage = errorWrapper && errorWrapper.querySelector('.product-form__error-message');
    try {
      const formData = new FormData(form);
      if (!formData.get('id')) throw new Error('Please select an available size first.');
      const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const rootUrl = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;
      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
        credentials: 'same-origin'
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.description || result.message || 'Could not start checkout. Please try again.');
      window.location.assign(`${rootUrl}checkout`);
    } catch (error) {
      if (errorMessage) {
        errorMessage.textContent = error.message || 'Could not start checkout. Please try again.';
        errorWrapper.hidden = false;
      } else {
        window.alert(error.message || 'Could not start checkout. Please try again.');
      }
      button.dataset.hmBusy = 'false';
      button.disabled = false;
      button.removeAttribute('aria-busy');
      label.textContent = originalLabel;
    }
  }

  function initAll() { document.querySelectorAll(ROOT).forEach(init); }
  document.addEventListener('click', handleBuyNow);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
